import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EMediaBreakpoint } from 'projects/shared/lib/enum/media/media-breakpoint.enum';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { ErrorCodeService } from '../../infrastructure/error-code.service';
import { EError } from '../../INTEGRA_Shop_Client';
import { IMediaService, IMediaServiceToken } from './media-service.interface';

@Injectable({
  providedIn: 'root'
})
export class MediaService implements IMediaService {
  private mediaBreakpointSource: BehaviorSubject<EMediaBreakpoint>;
  private mediaBreakpointChange: Observable<EMediaBreakpoint>;
  private mediaBreakpointCurrent: EMediaBreakpoint = EMediaBreakpoint.XS;

  public constructor() {
    this.mediaBreakpointSource = new BehaviorSubject<EMediaBreakpoint>(this.mediaBreakpointCurrent);
    this.mediaBreakpointChange = this.mediaBreakpointSource.asObservable();
  }

  public mediaUpdate(width: number): void {
    let mediaBreakPoint = this.mediaBreakPointGetByWidth(width);
    let mediaSizeChanged = this.mediaBreakpointCurrent != mediaBreakPoint;
    if (mediaSizeChanged) {
      this.mediaBreakpointCurrent = mediaBreakPoint;
      this.mediaBreakpointSource.next(mediaBreakPoint);
    }
  }

  public mediaBreakpointGet(): EMediaBreakpoint {
    return this.mediaBreakpointCurrent;
  }

  public mediaBreakpointChangeGet(): Observable<EMediaBreakpoint> {
    return this.mediaBreakpointChange;
  }

  private mediaBreakPointGetByWidth(width: number): EMediaBreakpoint {
    let mediaBreakPoint = this.mediaBreakpointCurrent;
    switch (true) {
      case width > 0 && width < 576:
        mediaBreakPoint = EMediaBreakpoint.XS;
        break;
      case width >= 576 && width < 768:
        mediaBreakPoint = EMediaBreakpoint.SM;
        break;
      case width >= 768 && width < 992:
        mediaBreakPoint = EMediaBreakpoint.MD;
        break;
      case width >= 992 && width < 1200:
        mediaBreakPoint = EMediaBreakpoint.LG;
        break;
      case width >= 1200 && width < 1400:
        mediaBreakPoint = EMediaBreakpoint.XL;
        break;
      case width >= 1400:
        mediaBreakPoint = EMediaBreakpoint.XXL;
        break;
      default:
        throw new BasicError("Invalid media width received. Could not adjust internal media size.", ErrorCodeService.formatErrorCode(EError.F330060));
    }
    return mediaBreakPoint;
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const MediaServiceProvider: Provider[] = [
  { provide: IMediaServiceToken, useExisting: MediaService }
];
